import {DATA_TYPE} from "./domain/constants";
import {DOMAIN_SCHEMA} from "./domain/schema";
import {DOMAIN_ENUM} from "./domain/enumMap";
import * as serializers from "./domain/serializer";

// 개별 serializer 는 정적 named export 로도 사용 가능:
//   import {serializeDocumentBff} from 'config/domain';
export * from "./domain/serializer";

// 기존 소비자 호환 표면 (Domain.serializeX(...) 호출 유지).
// 런타임 바인딩 루프 없이 정적으로 추적 가능한 plain object literal.
export const Domain = {
    DATA_TYPE,
    DOMAIN: DOMAIN_SCHEMA,
    DOMAIN_ENUM,
    ...serializers,
};

export default Domain;
